/**
 * What a new venue still needs before it can sell, in the runbook's order.
 *
 * Specification: ../test/setup-checklist.spec.ts. Each step is read from what
 * the venue holds, never from a box somebody ticked.
 */

import type { ScreenId } from "./nav";

export interface SetupFacts {
  /** The company as the receipt prints it: a name and an IČO. */
  readonly company: boolean;
  /** Items on the published menu: what a till can sell. */
  readonly menuItems: number;
  readonly tables: number;
  /** Active people, the owner among them. */
  readonly people: number;
  /** The venue's config has been published to the tills at least once. */
  readonly published: boolean;
  readonly devices: number;
  readonly pohoda: boolean;
}

export type SetupStepId = "company" | "menu" | "tables" | "people" | "publish" | "devices" | "pohoda";

export interface SetupStep {
  readonly id: SetupStepId;
  readonly done: boolean;
  readonly screen: ScreenId;
  readonly count?: number;
}

export function setupSteps(f: SetupFacts): readonly SetupStep[] {
  return [
    { id: "company", done: f.company, screen: "settings" },
    { id: "menu", done: f.menuItems > 0, screen: "menu", count: f.menuItems },
    { id: "tables", done: f.tables > 0, screen: "settings", count: f.tables },
    // The owner alone is not a staff.
    { id: "people", done: f.people > 1, screen: "staff", count: f.people },
    { id: "publish", done: f.published, screen: "settings" },
    { id: "devices", done: f.devices > 0, screen: "settings", count: f.devices },
    { id: "pohoda", done: f.pohoda, screen: "settings" },
  ];
}
